import React,{ useState } from 'react'
import contactImg from "../images/contact.svg"
export const Contact = () => {
  const [status, setStatus] = useState("");

  const submitForm = (e) => {
    e.preventDefault();
    const form = e.target;
    const data = new FormData(form);
    const xhr = new XMLHttpRequest();
    xhr.open(form.method, form.action);
    xhr.setRequestHeader("Accept", "application/json");
    xhr.onreadystatechange = () => {
      if (xhr.readyState !== XMLHttpRequest.DONE) return;
      if (xhr.status === 200) {
        form.reset();
        setStatus("SUCCESS");
      } else {
        setStatus("ERROR");
      }
    };
    xhr.send(data);
  };
    return (
        
        <div className="text-gray-100 container mx-auto my-0 py-24 " id="contact">
        <div
          className="max-w-screen-xl lg:flex mt-0 sm:mt-10 px-8 grid gap-8 grid-cols-1 md:grid-cols-2 md:px-12 lg:px-16 xl:px-32 py-16 mx-auto bg-transparent text-gray-900 rounded-lg  bg-primary-lighter">
          <div className="xl:w-1/2 flex flex-col justify-between px-4">
            <div>
              <h2 className="text-4xl lg:text-5xl font-bold leading-tight">Drop me a line...</h2>
              
            </div>
            <div className="mt-8 text-center mb-5">
              <img src={contactImg} alt="contact" />
            </div>
          </div>
          <form className="xl:w-1/2 px-4" onSubmit={submitForm}  action="https://formspree.io/f/mjvpnrna" method="post">
            <div>
              <span className="uppercase text-sm text-gray-600 font-bold">Full Name</span>
              <input className="w-full bg-gray-300 text-gray-900 mt-2 p-3 rounded-lg focus:outline-none focus:shadow-outline"
                type="text" placeholder=""  name="name"/>
            </div>
            <div className="mt-8">
              <span className="uppercase text-sm text-gray-600 font-bold">Email</span>
              <input className="w-full bg-gray-300 text-gray-900 mt-2 p-3 rounded-lg focus:outline-none focus:shadow-outline"
                type="email" name="_replyto" />
            </div>
            <div className="mt-8">
              <span className="uppercase text-sm text-gray-600 font-bold" >Message</span>
              <textarea
                className="w-full h-32 bg-gray-300 text-gray-900 mt-2 p-3 rounded-lg focus:outline-none focus:shadow-outline" name="message" />
            </div>
            <div className="mt-8">
            {/* <Button className="tracking-wide w-full">Submit</Button> */}
            {status === "SUCCESS" ? (
              <p className="text-4xl">Thanks!</p>
            ) : (
              
              <button className="main-btn" type="submit" onSubmit={submitForm} >Send</button>
            )}
            {status === "ERROR" && <p>Ooops! There was an error.</p>}
            
            </div>
            
          </form>
        </div>
      </div>
    )
}
